import * as React from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from 'src/components/ui/radio-group';
import { EscalatedListItem } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep6/EscalatedList/EscalatedListItem';
import { useEffect } from 'react';

export const EscalatedList = ({ control, watch, resetField, listItemContentClassName = '' }) => {
  const listValue = watch('action.0.action_escalated_list');

  useEffect(() => {
    resetField('action.0.receiver_email_addresses');
    resetField('action.0.message_before');
    resetField('action.0.message_after');
    resetField('action.0.action_message_type');
    resetField('action.0.message_close');
    resetField('action.0.action_fields_phone_number');
    resetField('action.0.action_fields_name');
    resetField('action.0.action_fields_email');
    resetField('action.0.action_fields_custom');
    resetField('action.0.action_data_collection');
  }, [listValue]);

  return (
    <div className={'input-container'}>
      <Controller
        control={control}
        name="action.0.action_escalated_list"
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            onValueChange={onChange}
            defaultValue={value}
            value={value}
            className="flex flex-col gap-2.5"
          >
            <EscalatedListItem
              isExpanded={listValue === 'handle_with_crm'}
              label={'Escalate immediately ⚠️'}
              description={
                'AI logs a ticket in your helpdesk as soon as an escalation is required.'
              }
              value={'handle_with_crm'}
              listItemContentClassName={listItemContentClassName}
            />
            <EscalatedListItem
              isExpanded={listValue === 'collect_and_escalate'}
              label={'Gather details and escalate 🧑‍💻'}
              description={
                'AI gathers contact or other details and then logs a ticket in your helpdesk.'
              }
              value={'collect_and_escalate'}
              listItemContentClassName={listItemContentClassName}
            />
            <EscalatedListItem
              isExpanded={listValue === 'forward_to_email'}
              label={'Forward to email ✉️'}
              description={'Send the full transcript or summary to an email address.'}
              value={'forward_to_email'}
              listItemContentClassName={listItemContentClassName}
            />
            <EscalatedListItem
              isExpanded={listValue === 'close'}
              label={'End conversation 🏁'}
              description={'Close the conversation with a custom message.'}
              value={'close'}
              listItemContentClassName={listItemContentClassName}
            />
          </RadioGroup>
        )}
      />
    </div>
  );
};
